import { useEffect, useState } from "react";
import {useAnimation, motion} from "framer-motion"
import { useInView } from "react-intersection-observer";
import { container2, child} from "../../../../variants"

import {ReactComponent as SlideIcon} from '../../../../assets/logos/prod-slide-icon.svg'
import {ReactComponent as LeftArrow} from '../../../../assets/logos/hr-left-arrow.svg'
import './index.scss'

const hrData = [
    {id:"data1", icon:<SlideIcon />, title:"Employee Database", content:"Centralize your team's vital info securely with our Employee Database simplified HR management made easy"},
    {id:"data2", icon:<SlideIcon />, title:"Organization Chart", content:"Streamline collaboration with our dynamic Organization Chart, effortlessly visualizing your company's structure, reporting lines, and team members."},
    {id:"data3", icon:<SlideIcon />, title:"Multiple Organization Policies", content:"Effortlessly customize and implement organizational policies to fit your unique needs, from HR guidelines to compliance protocols."},
    {id:"data4", icon:<SlideIcon />, title:"Employee Management", content:"Simplify onboarding with our intuitive self-service feature. New hires enter details smoothly, saving time and ensuring accuracy."},
    {id:"data5", icon:<SlideIcon />, title:"Bulk Employee Additions", content:"Need to scale up your team quickly? Easily add multiple employees at once for efficient workforce expansion."}
]

const HrSlide = () => {

    const [scrollRight, setScrollRight] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [data] = useState(hrData);

    const ctrls = useAnimation();

    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: false,
      });

    useEffect(() => {
        const updateDimensions = () => {
            const scrollingContainer:any = document.getElementById("hrSlideContainer");
            const child:any = document.getElementById("hrChild");
            const scrollAmount = Math.floor(scrollingContainer.offsetWidth / (child.offsetWidth))
            const right = hrData.length - scrollAmount
            setScrollRight(right)
        }

        updateDimensions();

        window.addEventListener("resize", updateDimensions);

        if (inView) {
            ctrls.start("visible");
        }
        if (!inView) {
            ctrls.start("hidden");
        }

        return () => {
            window.removeEventListener("resize", updateDimensions);
        };
        
    }, [data, ctrls, inView])

    const slideRight = () => {

        const scrollingContainer:any = document.getElementById("hrSlideContainer");
        const child:any = document.getElementById("hrChild");
       
        setScrollRight(prevScrollRight => prevScrollRight - 1);
        setScrollLeft(prevScrollLeft => prevScrollLeft + 1);
    
        
        scrollingContainer.scrollLeft += (child.offsetWidth + 40)

    }

    const slideLeft = () => {

        const scrollingContainer:any = document.getElementById("hrSlideContainer");
        const child:any = document.getElementById("hrChild");

        setScrollLeft(prevScrollLeft => prevScrollLeft - 1);
        setScrollRight(prevScrollRight => prevScrollRight + 1);

       
        scrollingContainer.scrollLeft -= (child.offsetWidth + 40)
       
    }

    const shouldShowLeftArrow = scrollLeft > 0;
    const shouldShowRightArrow = scrollRight > 0;

    
  return (
    <motion.div ref={ref} variants={container2} initial="hidden" animate={ctrls} id="hrSlide" className='hr-slide-par p-t-50 mb-40 d-flex flex-column'>
        <motion.div variants={child} className='hr-slide-child  d-flex flex-column  align-self-center'>
            <h3 className='h1-size font-weight-600 text-center'>Step into HR Excellence: <span className='col-secondary'>Walkzero</span> Leading the Way!</h3>
            <div className='hr-slide-one d-flex flex-column align-self-center'>
                <p className='font-1 p-size font-weight-400 text-center'>Optimize decision-making with Walkzero's customized HR workflow solutions, enhancing efficiency and effectiveness. Tailored to your specific needs, it streamlines operations for smarter, more strategic choices.</p>
            </div>
            <div className='hr-slide-two mt-20 d-flex flex-column align-items-center '>
                <ul id="hrSlideContainer" className='hr-slide-ul d-flex flex-row justify-content-between align-self-center'>
                        {hrData.map((each)=>
                            <li key={each.id} id="hrChild" className='hr-slide-items m-r-40'>
                                {each.icon}
                                <h3 className='hr-slide-head mt-10 text-18 font-weight-600'>{each.title}</h3>
                                <p className='hr-slide-para p-size font-weight-400'>{each.content}</p>
                            </li>
                        )}
                </ul>
            </div>
            <div className="hr-slide-icons d-flex flex-row justify-content-between align-self-center">
                <div className="slide-icon-flat d-flex flex-row align-items-center p-l-15">
                    <div style={{backgroundColor:scrollLeft === 0?"#68BE68":"#D9D9D9"}} className="w-px-30 h-px-3 rounded-5 m-r-10"></div>
                    <div style={{backgroundColor:scrollRight === 0?"#68BE68":"#D9D9D9"}} className="w-px-30 h-px-3 rounded-5 slide-line"></div>
                </div>
                <div className="d-flex flex-row icon-con">
                   {shouldShowLeftArrow && <LeftArrow onClick={slideLeft} className='icon-left-arrows'/>}
                    {shouldShowRightArrow && <LeftArrow onClick={slideRight} className='icon-right-arrows' />}
                </div>
            </div>
        </motion.div>
    </motion.div>
  )
}

export default HrSlide